<div class="sub-header-normal" (click)="comeBack()">
    <div class="container container--small">
        <div class="flex">
            <img [src]="back" />
            <div class="sub-header-normal__text">
                {{ title }}
            </div>
        </div>
    </div>
</div>
